// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c04a6719","455":"3909b5ea"}[chunkId] + ".chunk.js";
};